define.alias("shared/components/shared/badge", "settings/components/shared/badge");